import React, { Component } from 'react'; 

class DK extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Donkey Kong Country</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            </div>
          <iframe src="https://spritted.com/en/game/donkey-kong-country?embed" width="1080px" height="720px" title='DK'></iframe>
          </div>
            <div>
            <div className="containerjuego">
               <a href="/juego" className="button">Regresar</a>
            </div>
            </div>
            </span>
          </div>
          </div>
          );
    } 
} 

export default DK;